<style lang="scss" scoped>
@import "./beCareful.css";
.fontCla{
  margin: 10px 0;
  font-weight: 600;
}
.headerLogo {
    width: 12rem;
}
</style>

<template>
<div>
  <div style="text-align: center;box-shadow: 0px 0px 16px 0px #6666;">
    <img src="../../image/logoHeader.png" class="headerLogo">
    <div style="display: flex;justify-content: center;padding-bottom: 10px;">
      <div style="margin-right: 53%;cursor: pointer;">
        <span style="margin-right: 15px;font-size: 0.8rem;"  @click="langClick(1)">EN</span>
        <span style="font-size: 0.8rem;"  @click="langClick(2)">中文</span>
      </div>
      <div @click="lkClick()" style="font-size: 0.8rem;cursor: pointer;" v-if="lan == 'eng'">{{lk}}</div>
      <div @click="lkClick()" style="font-size: 0.8rem;cursor: pointer;" v-else>{{lk}}</div>
    </div>
  </div>
  
  <div class="content">
    <div v-for="(item,index) in parms.filepages_result" :key="index">
      <!-- 标题 -->
      <div class="title" v-if="item.bigtitle">{{item.bigtitle}}</div>
      <!-- 提示  -->
      <div class="tips" v-if="item.tips">{{item.tips}}</div>
      <!-- 第一级 -->
      <div class="flex" :class="{title:item.titlenum}" v-if="item.jibie == 1">
        <span v-if="item.titlenum" class="numCla">{{item.titlenum}}</span>
        <span style="color:#ffffff">{{item.title}}</span>
      </div>
      <!-- 第二级 -->
      <div class=" file_1" v-if="item.jibie == 2" >
        <span v-if="item.titlenum" class="numCla1">{{item.titlenum}}</span>
        <span>{{item.title}}</span>
      </div>
      <!-- 第三级 -->
      <div class="file_2" :style="index == parms.filepages_result.length-1?'border-bottom:1px solid #ddd;border-radius: 0 0 4px 4px;padding-bottom: 10px;':''"  v-if="item.jibie == 3">
        <span v-if="item.titlenum" class="numCla">{{item.titlenum}}</span>
        <span>{{item.title}}</span>
      </div>
    </div>

    <div v-for="(item,index) in parms.filepages_result1" :key="index + 100" >
      <div class="flex" :class="{title:item.titlenum}" v-if="item.jibie == 1" style="margin-top:20px">
        <span v-if="item.titlenum" class="numCla">{{item.titlenum}}</span>
        <span style="color:#ffffff">{{item.title}}</span>
      </div>
      <!-- 第二级 -->
      <div class=" file_1" :style="index == parms.filepages_result1.length-1?'border-bottom:1px solid #ddd;border-radius: 0 0 4px 4px;padding-bottom: 10px;':''" v-if="item.jibie == 2" >
        <span v-if="item.titlenum" class="numCla1">{{item.titlenum}}</span>
        <span>{{item.title}}</span>
      </div>
    </div>

    <div v-for="(item,index) in parms.filepages_result2" :key="index + 200" >
      <div class="flex" :class="{title:item.titlenum}" v-if="item.jibie == 1" style="margin-top:20px">
        <span v-if="item.titlenum" class="numCla">{{item.titlenum}}</span>
        <span style="color:#ffffff">{{item.title}}</span>
      </div>
      <!-- 第二级 -->
      <div class=" file_1" :style="index == parms.filepages_result2.length-1?'border-bottom:1px solid #ddd;border-radius: 0 0 4px 4px;padding-bottom: 10px;':''" v-if="item.jibie == 2" >
        <span v-if="item.titlenum" class="numCla1">{{item.titlenum}}</span>
        <span>{{item.title}}</span>
      </div>
    </div>

    <div v-for="(item,index) in parms.filepages_result3" :key="index + 300" >
      <div class="flex" :class="{title:item.titlenum}" v-if="item.jibie == 1" style="margin-top:20px">
        <span v-if="item.titlenum" class="numCla">{{item.titlenum}}</span>
        <span style="color:#ffffff">{{item.title}}</span>
      </div>
      <!-- 第二级 -->
      <div class=" file_1" :style="index == parms.filepages_result3.length-1?'border-bottom:1px solid #ddd;border-radius: 0 0 4px 4px;padding-bottom: 10px;':''" v-if="item.jibie == 2" >
        <span v-if="item.titlenum" class="numCla1">{{item.titlenum}}</span>
        <span>{{item.title}}</span>
      </div>
    </div>
    
    <div style="margin: 15px;" v-if="dataTime">{{dataTime}}</div>

    <div style="cursor: pointer;" class="lkBtn" @click="lkClick()" v-if="lan == 'eng'">{{lk}}</div>
    <div style="cursor: pointer;" class="lkBtn" @click="lkClick()" v-else>{{lk}}</div>
  </div>
</div>
</template>
<script>
import https from "@/plugins/http.js";

import apiUrl from "@/assets/api.js";

import App from "@/assets/app.js";

import demoJson from "./demo.json";
// import demoJsonEng from "./demo_eng.json";
import demoJsonEng from "./demo_eng.json"

export default {
  data() {
    return {
      websta: sessionStorage["onlinestate"],
      parms:{
        filepages_result:[],
        filepages_result1:[],
        filepages_result2:[],
        filepages_result3:[],
      },
      lk:'離開',
      dataTime:'',
      name:"",
      lan:'',
      ifEng: this.$i18n.locale == "eng",
    };
  },
  mounted() {
    this.websta =  sessionStorage["onlinestate"]?sessionStorage["onlinestate"]:'pc';
    this.lan = this.$route.query.lan;
    if (this.lan == "eng") {
      this.lk = "Leave"
    }else{
      this.lk = "離開"
    }
    this.getFilePages();
  },
  methods: {
    // 切换语言
    langClick(val){
      if (val == 1) {
        this.lan = "eng";
        this.getFilePages();
        this.lk = 'Leave';
        
      }else if (val ==2) {
        this.lan = "big5";
        this.getFilePages();
        this.lk = '離開';
      }
    },
    // 离开点击事件
    lkClick(){
      console.log("离开按钮");
      window.opener = null;
      window.open("", "_top").close()


    },
    getFilePages() {
      var url;
      if(location.protocol == 'https:') {
        url = 'https://www.qmisgroup.com:2347/groupweb/getNoticeofSubmissionanOnline'
      }else{
        url = 'http://202.130.113.149:2347/groupweb/getNoticeofSubmissionanOnline'
      }
      https.fetchLoginPost(url, {
        lan:this.lan,
      }).then((data) => {
        if (Object.is(data.qmiscode, 1000)) {
          this.parms.filepages_result = data.noticeofsubmission_result;
          this.parms.filepages_result1 = data.noticeofsubmission_result1;
          this.parms.filepages_result2 = data.noticeofsubmission_result2;
          this.parms.filepages_result3 = data.noticeofsubmission_result3;
          this.dataTime = data.noticeofsubmission_datetime;
        } else {
          App.oTool.warningT(data.qmismsg);
        }
      }).catch((err) => {
        console.log(err);
      });
    },


  },
};
</script>


